<template lang="pug">
  .title
    span.name(:style="{ color: theme == 'light' ? '#00387D' : '#ffffff ' }") {{ name }}
    span.bottom_line 
    router-link.more(:to="url" v-if="linkText") 
      | {{ linkText }} 
      img(src="../assets/img/icon_more_white.png")
</template>

<script>
export default {
  name: 'titles',
  props: {
    name: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'light'
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}
.name {
  color: #00387D;
  font-size: 30px;
  font-weight: bold;
}
.bottom_line {
  position: absolute;
  left: 0;
  bottom: 0;
  background: #1D86FF;
  width: 48px;
  height: 5px;
}
.more {
  width: 127px;
  height: 36px;
  line-height: 36px;
  background: #00387D;
  color: #fff;
  font-size: 16px;
  text-align: center;
  text-decoration: none;
  
  img {
    display: inline-block;
    width: 27px;
    margin-left: 2px;
    margin-bottom: 2px;
  }
}
@media(max-width: 768px){ 
  .title {
    height: 50px;
  }
  .name {
    font-size: 20px;
  }
  .bottom_line {
    width: 24px;
    height: 3px;
  }
  .more {
    width: 96px;
    font-size: 14px;
    height: 25px;
    line-height: 25px;
    img {
      width: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Title.vue